if (!customElements.get('tmg-card-slider')) {
  customElements.define(
    'tmg-card-slider',
    class TmgCardSlider extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-multiple') || this.track) return;
        this.track = this.querySelector('.tmg-card__track');
        this.slides = [...this.track.children];
        this.index = 0;

        this.onArrow = this.onArrow.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.querySelectorAll('.tmg-card__arrow').forEach((arrow) => arrow.addEventListener('click', this.onArrow));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        // Open on the image of the selected colour swatch (the first one), not necessarily photo 1.
        const selected = this.closest('.tmg-card')?.querySelector('.tmg-card__swatch[aria-pressed="true"]');
        const slide = Number(selected?.dataset.slide);
        if (selected && !Number.isNaN(slide) && this.slides[slide]) this.goTo(slide, true);
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track = null;
      }

      onArrow(event) {
        // Arrows sit over the product link: move the slider, never navigate.
        event.preventDefault();
        event.stopPropagation();
        const step = event.currentTarget.classList.contains('tmg-card__arrow--prev') ? -1 : 1;
        this.goTo(this.index + step);
      }

      goTo(requested, instant = false) {
        const count = this.slides.length;
        const target = ((requested % count) + count) % count;
        // Wrapping from last to first (or back) jumps instead of scrolling past every photo.
        const wraps = instant || Math.abs(target - this.index) > 1;
        // Slides are 1px wider than the track, so use their real offsets rather than index x width.
        this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: wraps ? 'auto' : 'smooth' });
        this.setActive(target);
      }

      onScroll() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const pitch = (this.slides[1]?.offsetLeft - this.slides[0].offsetLeft) || this.track.clientWidth || 1;
          this.setActive(Math.round(this.track.scrollLeft / pitch));
        });
      }

      setActive(index) {
        if (index === this.index && this.slides[index]?.classList.contains('is-active')) return;
        this.index = index;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      }
    }
  );
}

// Card colour swatches: select one to show that variant's image and send the card's links to it.
if (!window.tmgCardSwatchesBound) {
  window.tmgCardSwatchesBound = true;
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.tmg-card__swatch');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    const card = swatch.closest('.tmg-card');
    if (!card) return;

    card.querySelectorAll('.tmg-card__swatch').forEach((item) => item.setAttribute('aria-pressed', String(item === swatch)));

    // Jump straight to the variant's image (no scrolling); show a loading state until it has loaded.
    const slider = card.querySelector('tmg-card-slider');
    const slide = Number(swatch.dataset.slide);
    if (slider?.slides && !Number.isNaN(slide) && slider.slides[slide]) {
      const image = slider.slides[slide].querySelector('img');
      if (image && !image.complete) {
        card.classList.add('is-loading');
        image.loading = 'eager';
        const done = () => card.classList.remove('is-loading');
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
      }
      slider.goTo(slide, true);
    }

    const variantId = swatch.dataset.variantId;
    if (!variantId) return;
    card.querySelectorAll('a.tmg-card__slide, a.tmg-card__info').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('variant', variantId);
      link.setAttribute('href', url.pathname + url.search);
    });
  });
}
